import React from 'react'
import Input from '../../../components/Input'
import './QuestionSection.css'

interface QuestionSectionProps {
    value?: string
    onChange?: (value: string) => void
}
const QuestionSection: React.FC<QuestionSectionProps> = (props) => {
    const { value, onChange = () => undefined } = props
    return (
        <div className='question-section'>
            <div className='title'>
                <p className='h-title'>问题</p>
            </div>
            <Input
                placeholder='请输入知识点标题'
                multiple
                maxLength={500}
                onChange={onChange}
                value={value}
            />
        </div>
    )
}

export default QuestionSection
